<template>
  <div :class="{ 'h5-order-list': isH5 }">
    <div v-if="list.length">
      <component
        :is="handleOrderItem"
        @refresh="getList"
        @refund="refund"
        @showUseDetail="showUseDetail"
        @selectAddress="selectAddress"
        @showAddress="showAddress"
        v-for="item in list"
        :key="item.id"
        :orderInfo="item"
      ></component>
      <el-pagination
        class="page-wrap"
        :page-size="pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pageInfo.page"
        :total="pageInfo.total"
        :page-sizes="[10, 15, 20, 30]"
        @size-change="handleSizeChange"
        @current-change="handleChangePage"
      />
    </div>
    <!-- 空列表 -->
    <el-empty
      v-else
      style="height: 400px"
      description="暂无内容"
      :image="require('@/assets/img/live-list/empty.png')"
    ></el-empty>
    <course-usage
      :visible="courseUsageVisible"
      :data="currentGoods"
      type="order"
      @close="courseUsageVisible = false"
    />
    <refund-dialog
      :visible="refundDialogVisible"
      :data="currentGoods"
      :type="type"
      @close="refundDialogVisible = false"
      @refresh="getList"
    />
    <address-list ref="addressList" @confirm="confirmAddress" />
    <mail-address ref="mailAddress" :infor="currentGoods"></mail-address>
  </div>
</template>

<script>
import { isH5 } from "@saas/components";
import MobileOrderItem from "./MobileOrderItem";
import OrderItem from "./OrderItem";
import {
  getOrdersList,
  groupOrderRefund,
  saveOrderAddress,
} from "@saas/service-api/src/learning-center";
import { CourseUsage } from "@saas/components/src";
import { RefundDialog } from "@saas/components/src";
import AddressList from "@saas/components/src/components/address/List.vue";
import MailAddress from "./MailAddress.vue";
import formatTime from "@saas/components/src/utils/filters.js";
import { TRADE_STATUS, PAY_TYPE } from "@saas/components/src/constants";
export default {
  name: "VOrder",
  components: {
    CourseUsage,
    RefundDialog,
    OrderItem,
    AddressList,
    MailAddress,
    MobileOrderItem,
  },
  data() {
    return {
      loading: false,
      statistics: {},
      list: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      courseUsageVisible: false,
      refundDialogVisible: false,
      currentGoods: {},
      tradeStatus: TRADE_STATUS,
      parseTime: formatTime.formatSelfTime,
      type: 0,
      payType: PAY_TYPE,
      groupState: {
        1: "待成团",
        2: "已成团",
        3: "拼团失败",
      },
      isH5: false,
    };
  },
  computed: {
    handleOrderItem() {
      return this.isH5 ? MobileOrderItem : OrderItem;
    },
    handlePermission() {
      const roleKeys = ["Owner", "SuperAdmin", "CourseAdmin"];
      return roleKeys.includes(
        this.$store.state.user?.userInfo?.role_key || ""
      );
    },
  },

  mounted() {
    this.isH5 = isH5();
    this.getList();
  },
  methods: {
    formatTime(row, column, cellValue) {
      if (
        !cellValue ||
        (![2, 5].includes(row.state) && column.property !== "created_at")
      ) {
        return "-";
      } else {
        return this.parseTime(cellValue, "YYYY-MM-DD HH:mm:ss");
      }
    },
    // 手机号隐藏中间4位
    formatPhone(phone) {
      if (phone) {
        return String(phone).substr(0, 3) + "****" + String(phone).substr(7);
      } else {
        return "";
      }
    },
    dealValidityType(item) {
      if (item.validity_type === 1) {
        return `${this.parseTime(
          item.course_start_time,
          "YYYY-MM-DD HH:mm:ss"
        )} - ${this.parseTime(item.course_end_time, "YYYY-MM-DD HH:mm:ss")}`;
      } else if (item.validity_type === 2) {
        // 结束时间减去开始时间，判断多少天
        const endTime = item.course_end_time;
        const startTime = item.course_start_time;
        const day = (endTime - startTime) / (24 * 60 * 60);
        return `随到随学（${day}）天`;
      } else {
        return "永久有效";
      }
    },

    getList() {
      getOrdersList({
        page_no: this.pageInfo.page,
        page_size: this.pageInfo.pageSize,
      })
        .then((res) => {
          const { code, data, message } = res;
          if (code === 1) {
            this.list = data.list || {};
            this.pageInfo.total = data.total;
          } else {
            this.$message.error(message);
          }
        })
        .catch((err) => {
          console.error("获取订单列表失败>>>", err);
        });
    },
    // 使用详情
    showUseDetail(row) {
      this.currentGoods = row;
      this.courseUsageVisible = true;
    },
    // 地址列表
    selectAddress(row) {
      this.currentGoods = row;
      this.$refs.addressList.open();
    },
    // 展示地址
    showAddress(orderInfo) {
      this.$refs.mailAddress.open(orderInfo);
    },
    handleChangePage(page) {
      this.pageInfo.page = page;
      this.getList();
    },
    handleSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.getList();
    },
    refund(row) {
      // 如果退款处理状态为 待处理和同意退款， 不能退款
      if (+row.reply_result === 1) {
        this.$message.error("您有已经生成的退款单，请不要重复申请");
        return;
      }
      if (+row.reply_result === 2) {
        this.$message.error("该订单已经退款，不能重复申请退款");
        return;
      }
      this.currentGoods = row;
      this.type = 1;
      this.refundDialogVisible = true;
    },
    confirmAddress(address) {
      this.$confirm(
        "收货地址提交后不可更改，请确认信息无误，如需更改需要联系课程老师，是否确定提交？",
        "",
        {
          confirmButtonText: "确定提交",
          cancelButtonText: "修改信息",
          customClass: "saas-confirm-message",
          confirmButtonClass: "confirm-btn",
          cancelButtonClass: "cancel-btn",
        }
      )
        .then((res) => {
          this.saveOrderAddress(address);
        })
        .catch((res) => {});
    },
    saveOrderAddress(address) {
      saveOrderAddress({
        id: this.currentGoods.id,
        addr_id: address.id,
      }).then((res) => {
        if (res.code === 1) {
          this.$message.success("地址设置成功");
          this.$refs.addressList.close();
          this.getList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// 溢出隐藏
.multiline-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  /* 调整这里的数值以适应需要显示的行数 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
}
.active {
  color: $saas-theme-color;
}
.activity-info {
  color: #aaa;
}
.page-wrap {
  padding: 25px 0;
  text-align: right;
}
::v-deep .el-pagination {
  .el-pagination__total {
    font-size: 12px;
    color: #1d2129;
  }
  .el-select .el-input .el-input__inner {
    background: #f2f3f5;
    border-radius: 6px;
    border: none;
    font-size: 12px;
    color: #1d2129;
  }
  .el-pagination__editor.el-input .el-input__inner {
    background: #f2f3f5;
    border-radius: 6px;
    border: none;
    font-size: 12px;
    color: #1d2129;
  }
  .el-pager li {
    min-width: 28px;
    background: #f7f8fa;
    border-radius: 6px;
    padding: 0;
    margin: 0 5px;
    font-weight: 400;
    font-size: 12px;
  }
  .el-pager li.active {
    background: #e5faf5;
    color: $saas-theme-color;
    font-weight: 400;
    font-size: 12px;
  }
  .el-pagination .btn-prev,
  .btn-next {
    padding: 0 5px;
    min-width: 28px;
    margin: 0 5px;
    background: #f7f8fa;
    border-radius: 6px;
  }
}
.h5-order-list {
  ::v-deep .el-pagination {
    display: flex;
    flex-wrap: wrap;
    .el-pagination__total {
      margin-left: 10px;
      margin-bottom: 8px;
    }
    .el-pagination__sizes {
      width: calc(100% - 90px);
      text-align: left;
      margin-bottom: 8px;
    }
    .el-pagination__jump {
      width: 100%;
      text-align: left;
      margin-left: 10px;
      margin-top: 8px;
    }
  }
}
</style>
